import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getProviderProfileDetailAction,
  getProviderUploadDocuemntActionIBU,
} from "../../../redux/actions/ProviderProfileDetailAction";
import Modal from "react-modal";
import { ConfirmProviderUploadDocPopupIBU } from "./ConfirmProviderUploadDocPopupIBU";
import CustomPagination from "../../../common/CustomPagination";

export const ProviderUploadDocPopupIBU = ({
  rowData,
  searchFilter,
  apiParams,
  setRowData,
}) => {

  
  const dispatch = useDispatch();
  const [isApproveReject, setIsApproveReject] = useState(null);
  const [newSearchFilterTest, setNewSearchFilterTest] = useState({
    ticketId: rowData?.requestID,
    SessionId: rowData?.sessionID,
    page: 1,
    rows: 10,
    SortDirection: "DESC",
    SortColumn: "",
    ActionFlag: "A",
  });
  const providerPortalDetailReducer = useSelector(
    (state) => state?.providerPortalDetailReducer
  );

  useEffect(() => {
    dispatch(getProviderUploadDocuemntActionIBU(newSearchFilterTest));
  }, []);

  const handleClose = () => {
    dispatch(getProviderProfileDetailAction({ ...searchFilter, ...apiParams }));
    setRowData(null);
  };

  console.log("documentDetails",providerPortalDetailReducer?.getProviderUploadDoc?.documentDetails)

  return (
    <>
      <div className="modal-body" style={{ height: "100%" }}>
        <div className="back-buttondiv" onClick={handleClose}>
          <i className="fa-solid fa-circle-arrow-left"></i>
          <h6 style={{ cursor: "pointer" }}>Back</h6>
        </div>
        <div>
          <h4
            className="font-bold text-highlight"
            style={{ letterSpacing: "1px" }}
          >
            Upload Documents ({rowData?.providerName})
          </h4>
        </div>
        {providerPortalDetailReducer?.getProviderUploadDoc?.documentDetails
          ?.length ? (
          <>
            <div className="flexbetween_center">
              <h5 className="mt-4">Provider Documents</h5>
            </div>
            <div className="table-responsive __custom__properties mt-4">
              <table className="table">
                <thead>
                  <tr className="avanishtbl">
                    <th>Doc Type </th>
                    <th>Documents</th>
                    <th>Updated By</th>
                    <th>Updated Date</th>
                    <th>Status</th>
                    {/* <th>Is Permanent</th> */}
                    <th scope="col">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {providerPortalDetailReducer?.getProviderUploadDoc?.documentDetails?.map(
                    (ele, index) => {
                      return (
                        <tr key={index}>
                          <td>{ele?.docType}</td>
                          <td> 
                              <a
                                href={ele?.imageUrl}
                                target="blank"
                                className="text-decoration"
                              >
                                View
                              </a>
                           
                          </td>
                          <td>{ele?.updatedBy}</td>
                          <td>{ele?.updatedDate?.split("T")[0]}
                          </td>
                          <td>
                            <p
                              className={`status-style ${
                                ele?.requestStatus === "Accepted"
                                  ? "approved"
                                  : ele?.requestStatus === "Rejected"
                                  ? "rejected"
                                  : ele?.requestStatus === "InProgress"
                                  ? "notsubmited-status"
                                  : "pending"
                              }`}
                            >
                              {ele?.requestStatus}
                            </p>
                          </td>
                          {/* <td>{ele?.isVerified===true?"Yes":"No"}</td> */}
                          <td
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              setIsApproveReject({ ...ele, index: index });
                            }}
                          >
                            <img src="./images/edit-icon.png" alt="" />
                          </td>
                        </tr>
                      );
                    }
                  )}
                </tbody>
              </table>
              <div className="d-flex mt-4">
                {providerPortalDetailReducer?.getProviderUploadDoc?.totalRow !==
                  0 && (
                  <CustomPagination
                    totalCount={
                      providerPortalDetailReducer?.getProviderUploadDoc
                        ?.totalRow
                    }
                    perPageData={newSearchFilterTest?.rows}
                    searchFilter={newSearchFilterTest}
                    setSearchFilter={setNewSearchFilterTest}
                    apiCall={getProviderUploadDocuemntActionIBU}
                  />
                )}
              </div>
            </div>
          </>
        ) : null}
      </div>
      <Modal
        isOpen={isApproveReject}
        className="modal-add-user-popup modal-role-user-popup"
        overlayClassName="overlay-history-popup network-z-index"
        ariaHideApp={false}
      >
        <ConfirmProviderUploadDocPopupIBU
          isApproveReject={isApproveReject}
          setIsApproveReject={setIsApproveReject}
          rowData={rowData}
          handleClose={handleClose}
          newSearchFilterTest={newSearchFilterTest}
        />
      </Modal>
    </>
  );
};
